import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import app from './modules/app'

Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    downloadUrl: `${process.env.NEW_BASE_URL}/file/download?fileno=`,
    lastRoutePath: ''
  },
  modules: {
    user,
    app
  },
  getters,
  mutations: {
    setLastRoutePath(state, path) {
      state.lastRoutePath = path;
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js